import { PROPOSAL_AFIRMATIVE } from 'components/proposal_types';
import { useSelector } from 'react-redux';
import { GenericObject, ProposalEntity } from 'v2/models';
import { PERMISSION_NAME, hasPermission } from 'v2/utils/permissions';
import { filterApprovedProposals, getKeyCount } from 'v2/utils/proposalUtils';

export default function useSelectConversationCount(
  isAllRequests = true
): { [key: string]: number } | undefined {
  const selectConversationCount = useSelector((state: GenericObject) => {
    const isMonitor = hasPermission(state.permissions.permissions, [
      PERMISSION_NAME.MONITOR_SEARCHES_MASTER_ORG,
      PERMISSION_NAME.MONITOR_SEARCHES_ORG,
    ]);

    if (!isMonitor) {
      return state.chat?.unreadMessages;
    }
    const checkFunction = (proposal: ProposalEntity): boolean => {
      return Boolean(
        proposal.data_buyer_response &&
          proposal.data_buyer_response.action === PROPOSAL_AFIRMATIVE &&
          (isAllRequests && proposal.third_party_response ? false : true)
      );
    };

    const approvedProposals = filterApprovedProposals(
      state.proposals.multipleProposals
    );

    const conversationProposal = getKeyCount(approvedProposals, checkFunction);
    const conversation = {
      ...(state.chat?.unreadMessages || {}),
      ...(conversationProposal || {}),
    };
    Object.keys(conversation).forEach((key) => {
      conversation[key] =
        (conversationProposal?.[Number(key)] || 0) +
        (state.chat?.unreadMessages?.[key] || 0);
    });
    return conversation;
  });

  return selectConversationCount;
}
